import { ChangeDetectorRef, Component, OnDestroy, OnInit, Inject } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthLoginService } from '../auth.service';
import { UserAuthService } from '../../shared/services/user-auth.service';
import { CPATTERN, ENUM_THEMES } from '../../shared/helpers/app.constants';
import { ThemesSettingsService } from '../../shared/services/themes-settings.service';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { Logger, CryptoUtils, InteractionRequiredAuthError, ClientAuthError } from 'msal';
import { filter, takeUntil } from 'rxjs/operators';

import { Subject, Subscription } from 'rxjs';
// import { IdTokenClaims, PromptValue } from '@azure/msal-common';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  private readonly _destory = new Subject<void>();
  cvalidate = CPATTERN;
  loading: boolean = false;
  submitted: boolean = false;

  form: FormGroup;
  userNameOrEmailAddress: AbstractControl;
  password: AbstractControl;
  rememberClient: AbstractControl;
  isUserLogin: boolean = false;
  isDarkTheme: boolean;
  isIframe = false;
  loggedIn = false;
  idToken: string = '';
  constructor(
    private router: Router,
    private service: AuthLoginService,
    private userAuthService: UserAuthService,
    private ref: ChangeDetectorRef,
    private themesSettingsService: ThemesSettingsService,
    private authService: MsalService,
    private msalBroadcastService: BroadcastService,
     
  ) {
    if (this.userAuthService.currentTokenValue) {
      this.router.navigate(['/']);
    }
    // this.createForm();
  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;
    this.checkoutAccount();

  
    // this.authService.loginRedirect();
    //  this.msalBroadcastService.subscribe('msal:loginSuccess', () => {
    //   this.checkoutAccount();
    // });
    this.authService.handleRedirectCallback((authError, response) => {
      if (authError) {
        console.error('Redirect Error: ', authError.errorMessage);
        return;
      }
      this.idToken = response.idToken.rawIdToken;
        let userDetails = this.authService.getAccount();
        if(userDetails){
          this.userAuthService.getToken().then((response) =>{
            if(response && response.accessToken){
              this.userAuthService.storeJwtToken(response.accessToken);
                this.userAuthService.setAuth(response);
                this.router.navigate(['pages', 'dashboard']);
            }
        

          },(error) => {
            // this.userAuthService.getToken();
            if (error instanceof InteractionRequiredAuthError) {
              this.authService.loginRedirect({
                authority: 'https://prodlinqx.b2clogin.com/prodlinqx.onmicrosoft.com/B2C_1_PROD',
                scopes: ['https://prodlinqx.onmicrosoft.com/PROD_WebApi_Scope/prod_scp_rw'],
              });
            } else if (error instanceof ClientAuthError) {
              // Specific handling for ClientAuthError including timeouts
              console.error('ClientAuthError:', error);
              // Retry logic or user notification
              if (error.errorCode === 'token_renewal_timeout') {
                alert('Token renewal timed out. Please try logging in again.');
                this.authService.loginRedirect({ 
                  authority: 'https://prodlinqx.b2clogin.com/prodlinqx.onmicrosoft.com/B2C_1_PROD',
                scopes: ['https://prodlinqx.onmicrosoft.com/PROD_WebApi_Scope/prod_scp_rw'],
                });
              } else {
                this.authService.loginRedirect({ 
                  authority: 'https://prodlinqx.b2clogin.com/prodlinqx.onmicrosoft.com/B2C_1_PROD',
                scopes: ['https://prodlinqx.onmicrosoft.com/PROD_WebApi_Scope/prod_scp_rw'],
                 });
              }
            } else {
              console.error('Unexpected error:', error);
            }
          }
        );
          
        }
      // this.isUserLogin = this.authService.instance.getAllAccounts().length > 0;
    });
    this.authService.setLogger(new Logger((logLevel, message, piiEnabled) => {
      // console.log('MSAL Logging: ', message);
    }, {
      correlationId: CryptoUtils.createNewGuid(),
      piiLoggingEnabled: false
    }));
    // this.login(); // Initiate login process
  }
  checkoutAccount() {
    this.loggedIn = !!this.authService.getAccount();
    // this.userAuthService.getToken(this.idToken);
    this.login1();
    if(this.loggedIn){
      this.router.navigate(['pages', 'dashboard']);
    }
  }
  ngOnDestroy(): void {
    this._destory.next();
    this._destory.complete();
  }

  login1(): void {
    // this.loading = true;
    // const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

    // if (isIE) {
      // this.router.navigate(['/']);

      // this.authService.loginRedirect();
    // } else {
      // this.authService.loginPopup();
    // }
    // // Check if user is already logged in to prevent unnecessary redirects
    if (!this.authService.getAccount()) {
      this.router.navigate(['/']);
      this.authService.loginRedirect();
    }
  }
 
  // checkUserLogin(): void {
  //   this.isUserLogin = this.authService.instance.getAllAccounts().length > 0;
  //   console.log('User logged in:', this.isUserLogin);
  //   if (this.isUserLogin) {
  //     // User is logged in, perform necessary actions
  //   }
  // }
}


  // createForm() {
  //   this.form = new FormGroup({
  //     userNameOrEmailAddress: new FormControl('', Validators.compose([Validators.required, Validators.pattern(this.cvalidate.EMAIL)])),
  //     password: new FormControl('', [Validators.required]),
  //     rememberClient: new FormControl(true)
  //   });
  //   this.userNameOrEmailAddress = this.form.controls['userNameOrEmailAddress'];
  //   this.password = this.form.controls['password'];
  //   this.rememberClient = this.form.controls['rememberClient'];
  // }

  // onSubmit() {
  //   if (this.form.valid) {
  //     this.loading = true;
  //     this.submitted = true;
  //     this.ref.detectChanges();
  //     const obj = this.form.value;
  //     this.service.login(obj, () => {
  //       this.loading = false;
  //       this.submitted = false;
  //       this.ref.detectChanges();
  //     })
  //       .subscribe(
  //         (response) => {
  //           if (response && response.result && response.result.accessToken) {
  //             this.userAuthService.setAuth(response.result);
  //             if (response.result.isChangePassword) {
  //               this.router.navigate(['pages', 'dashboard']);
  //             } else {
  //               this.router.navigate(['auth', 'changePasswordDefault']);
  //             }
  //           }
  //         }, (error) => {
  //           this.userAuthService.purgeAuth();
  //         }
  //       );
  //   }
  // }

  // forgetPassword() {
  //   this.router.navigate(['auth/forgetPassword']);
  // }

